import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { enumToArray } from 'src/app/shared/helpers/enumToArray';
import { EmployeeEmailValidator } from 'src/app/shared/validators/employee-email.validator';
import { EmployeePhoneNumberValidator } from 'src/app/shared/validators/employee-phone-number.validator';
import { MatchValidator } from 'src/app/shared/validators/match-validator';
import { IEditUser, Language } from '../models/employee';
import { EmployeeService } from '../services/employee.service';

@Component({
    selector: 'app-company-employee-edit',
    templateUrl: './company-employee-edit.component.html',
    styleUrls: ['./company-employee-edit.component.scss'],
    standalone: false
})
export class CompanyEmployeeEditComponent implements OnInit {

  constructor(
    private employeeService: EmployeeService
  ) { }

  public active = false;
  public phoneNumberMask: string = "000-000-00-00";

  languages = enumToArray(Language, "languages.")

  get passwordMatchError() {
    return (
      this.editForm.getError('mismatch') &&
      this.editForm.get('confirmPassword')?.touched
    );
  }

  // check Validation in func setFormValidators() below!
  public editForm: UntypedFormGroup = new UntypedFormGroup({
    firstName: new UntypedFormControl("", Validators.required),
    lastName: new UntypedFormControl("", Validators.required),
    email: new UntypedFormControl(null, {
      validators:[Validators.required, Validators.email],
      asyncValidators:EmployeeEmailValidator(this.employeeService),
      updateOn:"blur"}),
    password: new UntypedFormControl("", [Validators.required, Validators.minLength(6)]),
    confirmPassword: new UntypedFormControl("", Validators.required),
    phoneNumber: new UntypedFormControl("000-000-00-00", {
      validators:[Validators.pattern('[0-9]{10}')],
      asyncValidators: [EmployeePhoneNumberValidator(this.employeeService)]
    }),
    role: new UntypedFormControl(""),
    language: new UntypedFormControl(0, Validators.required),
  },
  [MatchValidator('password','confirmPassword')]);

  public passwordResetForm: UntypedFormGroup = new UntypedFormGroup({
    password: new UntypedFormControl("", [Validators.required, Validators.minLength(6)]),
    newPassword: new UntypedFormControl("", [Validators.required, Validators.minLength(6)]),
    confirmNewPassword: new UntypedFormControl("", [Validators.required, Validators.minLength(6)])
  });

  @Input() public isNew = false;
  @Input() public set model(employee: IEditUser) {
    this.editForm.reset(employee);

    // Update async validator on phoneNumber control with current employee id
    const phoneControl = this.editForm.get('phoneNumber');
    if (phoneControl) {
      phoneControl.setAsyncValidators(EmployeePhoneNumberValidator(this.employeeService, employee?.id));
      phoneControl.updateValueAndValidity(); // trigger validation with new validator
    }

    // toggle the Dialog visibility
    this.active = employee !== undefined;
  }

@Output() cancel: EventEmitter<undefined> = new EventEmitter();
@Output() save: EventEmitter<IEditUser> = new EventEmitter();

  ngOnInit(): void {
    
  }

  ngOnChanges(){
    this.setFormValidators()
  }

  setFormValidators(){
    const emailControl = this.editForm.get('email');
    const passwordControl = this.editForm.get('password');
    const confirmPasswordControl = this.editForm.get('confirmPassword');
    if(!this.isNew){
      emailControl.setValidators(null);
      passwordControl.setValidators(null);
      confirmPasswordControl.setValidators(null);
    } else {
      emailControl.setValidators([Validators.required, Validators.email]);
      passwordControl.setValidators([Validators.required, Validators.minLength(6)]);
      confirmPasswordControl.setValidators(Validators.required);
    }
  }

  public onSave(e: PointerEvent): void {
    e.preventDefault();
    this.save.emit(this.editForm.value);
    this.active = false;
  }

  public onCancel(e: PointerEvent): void {
    e.preventDefault();
    this.closeForm();
  }

  public closeForm(): void {
    this.active = false;
    this.cancel.emit();
  }

}